import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=5bc01789&scoped=true&"
import script from "./NavButtons.vue?vue&type=script&lang=js&"
export * from "./NavButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=5bc01789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc01789",
  null
  
)

export default component.exports